import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Closing invite — points to About for deeper story without repeating it.
 */
function HomeInviteSection() {
  return (
    <section
      className="home-invite"
      id="invite"
      style={{
        backgroundImage:
          'linear-gradient(105deg, rgba(247, 250, 248, 0.94) 0%, rgba(247, 250, 248, 0.78) 50%, rgba(247, 250, 248, 0.55) 100%), url(/img/startup-pen.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="home-invite-inner ch-reveal">
        <h2>Ready when you are</h2>
        <p>
          Whether you are assembling a founding team or filling a critical seat, start on the hub —
          and read our story when you want the fuller picture.
        </p>
        <div className="home-hero-cta">
          <Link to="/signup" className="home-btn home-btn-primary">
            Create account
          </Link>
          <Link to="/about" className="home-btn home-btn-secondary">
            About CofounderHubs
          </Link>
        </div>
      </div>
    </section>
  );
}

export default HomeInviteSection;
